<div
  [ngStyle]="{
    height: bannerHeight,
  }"
  class="fixed bottom-0 left-64 right-0 z-[1000] flex items-center justify-between px-4 py-[9px] shadow-banner"
  [ngClass]="{
    'bg-aux-green-light-1': !disabled,
    'bg-aux-gray-light-1': disabled,
  }"
>
  @if (!disabled) {
    <div class="flex items-center font-semibold text-aux-blue-dark-1">
      <aux-icon name="Sparkles" class="mr-2" />

      {{ closeMonthText }}
    </div>
  } @else {
    <div class="font-semibold text-aux-gray-darkest">
      You can’t close the month until you review inputs, expenses, and complete your checklist.
    </div>
  }

  <div class="flex items-center">
    <aux-assign-month-close />

    <span
      class="btn btn--secondary ml-4 h-[40px] cursor-pointer whitespace-nowrap text-sm font-normal"
      [routerLink]="routerLink"
    >
      Review Checklist
    </span>

    <span
      [auxTooltip]="closeMonthTooltip"
      [ngClass]="{ 'cursor-not-allowed': disabled || !hasClosePermission }"
    >
      <span
        type="button"
        class="btn ml-4 h-[40px] min-w-[206px] whitespace-nowrap text-sm font-bold"
        [ngClass]="{
          'btn--success cursor-pointer': !disabled && hasClosePermission,
          'pointer-events-none border-aux-gray-light-2 bg-aux-gray-light-2 text-aux-gray-dark-1':
            disabled || !hasClosePermission,
        }"
        (click)="onCloseMonth()"
      >
        <aux-icon name="Check" />

        {{ closeMonthBtnText }}
      </span>
    </span>
  </div>
</div>
